<template>
  <v-card
    variant="outlined"
    class="pb-4 preview-default-content"
  >
    <v-row v-if="checklistPreviewPending"
           class="d-flex align-center h-100">
      <v-col>
        <div class="text-center">
          <AppLoader/>
        </div>
      </v-col>
    </v-row>
    <template v-else>
      <template v-if="selectedChecklist">
        <v-toolbar class="preview-header" flat dense>
          <v-toolbar-title class="text-text-primary mb-2">
            <h4 class="text-truncated">{{ selectedChecklist.name }}</h4>
          </v-toolbar-title>
        </v-toolbar>

        <v-divider></v-divider>

        <!-- Display the checklist for all levels -->
        <v-card-text class="overflow-y-auto mt-2"
                     :style="{ height: `${400 - 48}px` }"> <!-- preview default height - preview header height -->
          <template v-if="!checklistPreviewError">
            <SavedChecklistPreviewItem v-for="checklist in checklistPreviewSections"
                                        :key="checklist.id"
                                        :item="checklist"
                                        :depth="1"
            >
              <span class="text-text-secondary">{{computedTitle(checklist)}}</span>
            </SavedChecklistPreviewItem>
          </template>
          <div v-else class="text-center">
            {{ $t('project.checklist.dialogs.SaveChecklistFromTemplateDialog.checklistPreview.error') }}
          </div>
        </v-card-text>
      </template>
      <v-row v-else class="d-flex align-center h-100">
        <v-col>
          <div class="d-flex flex-column justify-center align-center">
            <!--
              Stack of two images together because of the design
            -->
            <v-img src="@/assets/img/checklist/checklist-preview-illustration-1.svg" width="200" />
            <v-img src="@/assets/img/checklist/checklist-preview-illustration-1.svg" width="200"
                   style="margin-top: -55px; margin-right: -45px;"
            />
            <div class="text-center">
              {{ $t('project.checklist.dialogs.SaveChecklistFromTemplateDialog.checklistPreview.home') }}
            </div>
          </div>
        </v-col>
      </v-row>
    </template>
  </v-card>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  import AppLoader from '@/common/AppLoader.vue'
  import { toast } from '@/common/utils/toast'
  import SavedChecklistPreviewItem from '@/project/checklist/dialogs/SavedChecklistPreviewItem.vue'
  import {
    GET_SAVED_CHECKLIST_PREVIEW,
    GET_LEXISNEXIS_CHECKLIST_PREVIEW,
  } from '@/store/modules/checklist/action_types'

  export default {
    name: 'SavedChecklistPreview',
    components: {
      AppLoader,
      SavedChecklistPreviewItem,
    },
    props: {
      isLexisNexisChecklist: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState('checklist', [
        // SavedChecklists
        'selectedSavedChecklist',
        'savedChecklistPreviewPending',
        'savedChecklistPreview',
        'savedChecklistPreviewError',
        // LexisNexisChecklists
        'selectedLexisNexisChecklist',
        'lexisNexisChecklistPreviewPending',
        'lexisNexisChecklistPreview',
        'lexisNexisChecklistPreviewError',
      ]),
      selectedChecklist () {
        return this.isLexisNexisChecklist
        ? this.selectedLexisNexisChecklist
        : this.selectedSavedChecklist
      },
      checklistPreviewPending () {
        return this.isLexisNexisChecklist
        ? this.lexisNexisChecklistPreviewPending
        : this.savedChecklistPreviewPending
      },
      checklistPreviewSections () {
        const savedChecklistPreview = this.isLexisNexisChecklist
          ? this.lexisNexisChecklistPreview
          : this.savedChecklistPreview

        return savedChecklistPreview
      },
      checklistPreviewError () {
        return this.isLexisNexisChecklist
        ? this.lexisNexisChecklistPreviewError
        : this.savedChecklistPreviewError
      },
    },
    watch: {
      'selectedChecklist.id': {
        handler (value) {
          if (value) {
            this.getChecklistPreview()
          }
        },
      },
    },
    methods: {
      ...mapActions('checklist', [
        GET_SAVED_CHECKLIST_PREVIEW,
        GET_LEXISNEXIS_CHECKLIST_PREVIEW,
      ]),
      async getChecklistPreview () {
        try {
          if (this.isLexisNexisChecklist) {
            await this.GET_LEXISNEXIS_CHECKLIST_PREVIEW({
              todoListId: this.selectedChecklist.id,
            })
          } else {
            await this.GET_SAVED_CHECKLIST_PREVIEW({
              todoListId: this.selectedChecklist.id,
            })
          }
        } catch (e) {
          toast.error(this.$t('project.checklist.dialogs.SaveChecklistFromTemplateDialog.checklistPreview.error'))
        }
      },
      computedTitle (checklist) {
        return `${checklist.positionDisplay ?? checklist.display}. ${(checklist.title || '')}`
      },
    },
  }
</script>

<style scoped lang="scss">
  .preview-header {
    background-color: rgb(var(--v-theme-surface-secondary)) !important;
    height: 48px !important; // 48 to align with table header height
  }
  .preview-default-content {
    // Arbitrary height: it leaves enough room for the contents while keeping the
    // container mostly visible in most viewports
    height: 300px;
    position: sticky;
    top: 0;
  }
</style>
